var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.6 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#363565;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-Sidebar",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log_Out",
    "data-name": "Log Out",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.067,4A.517.517,0,0,0,9.6,3.5V.5A.517.517,0,0,0,9.067,0H.533C.514,0,.5.008.478.009S.43.016.406.021A.578.578,0,0,0,.252.083C.241.091.226.091.215.1L.205.111A.5.5,0,0,0,.063.268.429.429,0,0,0,.048.31.455.455,0,0,0,.006.427a.32.32,0,0,0,0,.044C.007.481,0,.49,0,.5v10a.51.51,0,0,0,.429.49l5.333,1a.533.533,0,0,0,.105.01.549.549,0,0,0,.338-.114.487.487,0,0,0,.2-.386V11H9.067a.517.517,0,0,0,.533-.5v-3a.535.535,0,0,0-1.067,0V10H6.4V2a.505.505,0,0,0-.38-.479L4.167,1H8.533V3.5A.518.518,0,0,0,9.067,4Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.162022d416c7f9ea15649b923bd92e23.svg";
export { ForwardRef as ReactComponent };